import React, {
	useState
}from "react"
import {
	Row, Col
}from "antd"
import {
	Link
}from "react-router-dom"
import {
	useWindowDimensions
}from "../../helpers/useWindowDimensions"
import CustomMenu from "../../components/CustomMenu"
import routes from "./routes"
import "./style.css"

const NRI = (props) => {
	const { withCatalog = true, withHeader = false } = props
	const [currentItem, setCurrentItem] = useState(0)
	const { width } = useWindowDimensions()
	const tableSize = width < 1020 ? "small" : "middle"
	const handleChange = (value) => {
		setCurrentItem(value)
	}
	const Element = routes[currentItem].render
	return (
		<div className="nsi">
			{ withHeader && (
				<h1 className="nsi-header">
Справочники и классификаторы
				</h1>
			) }
			<Row>
				<Col
					className="nsiMenu"
					span={ 5 }
				>
					<CustomMenu selectedKey={ currentItem }>
						{ routes.map((item, index) => {
							return (
								(!item.catalog || withCatalog) && (
									<Link
										key={ index }
										to="#"
										onClick={ () => handleChange(index) }
									>
										<li>
											<div>
												<span>
													{ item.text }
												</span>
											</div>
										</li>
									</Link>
								)
							)
						}) }
					</CustomMenu>
				</Col>
				<Col
					className="nsiContent"
					span={ 19 }
				>
					<Element tableSize={ tableSize } />
				</Col>
			</Row>
		</div>
	)
}

export default NRI
